/**
 * 封装app
 * @param {Component} app 需要挂载的组件
 * @param {schoolId} schoolId schoolId
 */

 import { createApp, computed, ref, reactive } from 'vue';
import { jsonp, getFetch, postFetch } from './http';
import * as utils from './utils';
import api from '../pages/api/index'
import './../assets/css/reset.scss';
import './../assets/font/iconfont.css';
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import infiniteScroll from 'vue-infinite-scroll'

let relativeTime = require('dayjs/plugin/relativeTime')
dayjs.locale('zh-cn')
dayjs.extend(relativeTime)

// import 'element-plus/packages/theme-chalk/src/base.scss'
let baseUrl = ''
// const objectStatus = ref(true)
export default function (app, schoolId = 0, config = {}) {
    const http = {};
    const vm = createApp(app);
    vm.use(infiniteScroll)

    //判断移动端访问跳转
    // VUE_APP_H5  1 有h5页面， 0 无
    console.log(navigator.userAgent);
	if ((navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) && process.env.VUE_APP_H5 == 1) {
		window.location.href= `//${process.env.VUE_APP_HOST}/h5/index.html`
	} else {
    }
    // vm.provide('$objectStatus', computed(() => objectStatus.value))
    // http.getFileUrl().then((res) => {
    //     vm.config.globalProperties.$fileHost = res
    // })
    // async function getObjectStatus() {
    //     const res = await api.getObjectStatus()
    //     console.log('状态', res);
    //     objectStatus = res.status
    // }
    // getObjectStatus()
  
    vm.config.globalProperties.$jsonp = jsonp;
    vm.config.globalProperties.$schoolId = schoolId;
    vm.config.globalProperties.$http = http;
    vm.config.globalProperties.$utils = utils;
    vm.config.globalProperties.$get = getFetch;
    vm.config.globalProperties.$post = postFetch;
    vm.config.globalProperties.$baseUrl = baseUrl
    vm.config.globalProperties.$dayjs = dayjs

    return vm;
}